/**
 * The Go Live Checks telemetry category, shared by the intro (fired from every publish surface,
 * guest site included) and the editor's wizard. In `@shared` so the intro can report under the same
 * category without importing admin code.
 */
export const GO_LIVE_CHECKS_TELEMETRY_CATEGORY = 'admin.goLiveChecks';
